import * as React from 'react'
import { Modal } from 'react-bootstrap'
import ReactPlayer from 'react-player'

interface ClassInterface {
    show: boolean,
    videoURL: string,
    setshow: any,
}

const Video = ({ show, setshow, videoURL }: ClassInterface) => {

    const handleClose = () => {
        setshow(!show);
    }

    return (
        <div>
            <Modal show={show} onHide={handleClose} className='react-player-modal'>
                <Modal.Body className='p0'>
                    <ReactPlayer
                        height={"400px"}
                        url={videoURL}
                        playing={true}
                        controls={true}
                    />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Video


// WEBPACK FOOTER //
// ./src/components/Video/index.tsx